import HeroContainer from "../../containers/HeroContainer.tsx";
import Landing from "../Landing.tsx";
import LandingCta from "../LandingCta.tsx";
import LandingInfo from "../LandingInfo.tsx";

const LandingPage = () => (
  <HeroContainer
    headerContent={<Landing />}
    bodyContent={<LandingInfo />}
    fullWidthBodyContent={<LandingCta />}
  />
);

export default LandingPage;
